import dayjs from "dayjs";
import { Language } from "../../components";

export function getLastReviewData(
  last_review_date: any[],
  language: Language
): string {
  const lastReviewData = last_review_date?.map(
    (item) => item?.last_review_date
  )?.[0];
  switch (language) {
    case Language.TC:
    case Language.SC:
      return dayjs(lastReviewData).format("YYYY年M月D日");
    case Language.EN:
    default:
      return dayjs(lastReviewData).format("DD MMMM YYYY");
  }
}
